import { Injectable, inject } from '@angular/core';
import { Auth, createUserWithEmailAndPassword, sendEmailVerification, applyActionCode } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private auth: Auth = inject(Auth);

  async registerUser(email: string, password: string):Promise<void> {
    try {
      if (this.auth.app.options && (this.auth.app.options.apiKey === "YOUR_API_KEY" || !this.auth.app.options.apiKey)) {
        console.warn("Using Firebase Auth mock mode because credentials are not configured.");
        return Promise.resolve();
      }
      const userCredential = await createUserWithEmailAndPassword(this.auth, email, password);
      
      // Configuration to redirect back to the app after clicking the link
      const actionCodeSettings = {
        // The URL to redirect to for sign-in completion.
        url: window.location.origin + '/#/verification-success',
        handleCodeInApp: false, // We want the default Firebase handler to process the code, then redirect
      };

      await sendEmailVerification(userCredential.user, actionCodeSettings);
    } catch (error) {
      console.error("Error registering user:", error);
      throw error;
    }
  }

  // Optional: If we want to handle the oobCode ourselves instead of letting Firebase do it.
  // But setting handleCodeInApp: false and passing url will make Firebase verify it
  // on their hosted widget and then offer a "Continue" button back to our url.
  // For a fully seamless custom flow (no Firebase widget), handleCodeInApp must be true
  // and the Action URL in Firebase Console must be configured to point to our app.
  // We'll provide the method just in case.
  async verifyEmailCode(code: string): Promise<void> {
    return applyActionCode(this.auth, code);
  }
}
